import * as SentryInstance from '@sentry/react';

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) return;

  SentryInstance.init({
    dsn,
    environment: import.meta.env.VITE_ENV,
    // eslint-disable-next-line no-undef
    release: APP_VERSION,
    tracesSampleRate: 0.1,

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
};
